import React, { useLayoutEffect } from 'react';
import { Form, FormInstance, Switch } from 'antd';
import { Catcher } from '../../';
import { isTrueOnFields } from './index';
import { apiMessagesGetFormRules } from '../../../middleware';
import { ITrField, tF } from '../../../translate';

type IToggleListMyAlarm = {
    fields: ITrField[];
    form: FormInstance;
    isLoading?: boolean;
    nonSelectedField?: string;
};

export const ToggleListMyAlarm: React.FC<IToggleListMyAlarm> = ({
    fields,
    form,
    isLoading,
    nonSelectedField,
}: IToggleListMyAlarm) => {
    function checkIsOnChecked(): void {
        if (nonSelectedField) {
            const isSelected = isTrueOnFields(form, fields);
            if (isSelected) {
                form.setFields([{ name: nonSelectedField, errors: [] }]);
            } else {
                form.setFields([{ name: nonSelectedField, errors: ['Need to select at least one item'] }]);
            }
        }
    }

    useLayoutEffect(() => {
        if (nonSelectedField) {
            setTimeout(() => {
                checkIsOnChecked();
            }, 500);
        }
    }, [nonSelectedField]);

    return (
        <Catcher>
            {fields.map((field) => {
                return (
                    <Form.Item
                        className={'switchField'}
                        label={tF(field)}
                        name={field}
                        rules={apiMessagesGetFormRules}
                        key={field}
                        valuePropName="checked"
                    >
                        <Switch loading={isLoading} onChange={checkIsOnChecked} />
                    </Form.Item>
                );
            })}
            {nonSelectedField ? (
                <Form.Item
                    name={nonSelectedField}
                    rules={apiMessagesGetFormRules}
                    key={nonSelectedField}
                    className={'ant-form-item-without-content'}
                />
            ) : null}
        </Catcher>
    );
};
